import { GSTConstants } from '../Constants';

export function Gst(state = {}, action) {
    switch (action.type) {
        case GSTConstants.POST_GST_REQUEST:
            return {
                ...state,
                postloading: true,
                postResult: null,
                postError: null
            };
        case GSTConstants.POST_GST_SUCCESS:
            return {
                ...state,
                postloading: false,
                postResult: action.GST
            };
        case GSTConstants.POST_GST_FAILURE:
            return {
                ...state,
                postloading: false,
                postError: action.error
            };
        case GSTConstants.POST_MUTIPLE_GST_REQUEST:
            return {
                ...state,
                GSTloading: true
            };
        case GSTConstants.POST_MUTIPLE_GST_SUCCESS:
            return {
                ...state,
                GSTloading: false,
                result: action.GST
            };
        case GSTConstants.POST_MUTIPLE_GST_FAILURE:
            return {
                ...state,
                GSTloading: false,
                error: action.error
            };
        case GSTConstants.POST_GST_DATA_REQUEST:
            return {
                ...state,
                GSTloading: true,
                postResult: null
            };
        case GSTConstants.POST_GST_DATA_SUCCESS:
            return {
                ...state,
                GSTloading: false,
                GSTResult: action.GST
            };
        case GSTConstants.POST_GST_DATA_FAILURE:
            return {
                ...state,
                GSTloading: false,
                GSTError: action.error
            };
        default:
            return state
    }
}